import React from "react";

import { AttachmentDomainIcon } from "./styles";
import EmptySourceImage from "assets/images/article/empty-source.png";

interface ISourceIcon {
  domain?: string;
  favicon?: string;
}

const onIconError = (event: React.SyntheticEvent<HTMLImageElement>) => {
  event.currentTarget.onerror = null;
  event.currentTarget.src = EmptySourceImage;
};

const SourceIcon: React.FC<ISourceIcon> = ({ domain, favicon }) => (
  <AttachmentDomainIcon
    className="article"
    alt={domain}
    src={favicon || EmptySourceImage}
    onError={onIconError}
  />
);

export default SourceIcon;
